import { OrganizationFormValuesT } from '.';

export const validateOrganizationForm = (values: OrganizationFormValuesT) => {
  const errors: Record<string, string> = {};

  if (!values) {
    return errors;
  }

  if (!values.organization?.name?.length) {
    errors.name = 'Required';
  }

  return errors;
};
